export default __webpack_public_path__ + "slices/main/assets/public/media/logos/businessinsider.9b86adb6abe15a77d73283dc836b188d.png";